import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const Box = styled.div`
  border-radius: 0 0 4px 4px;
  background-color: ${getToken('color-danger')};
  color: ${getToken('color-neutral-white')};
  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
  padding: 4px 8px 2px 8px;
`

function FormAlertV2({ message }) {
  if (message) {
    return (
      <Box role="alert">
        <span>{message}</span>
      </Box>
    )
  } else {
    return null
  }
}

FormAlertV2.propsTypes = {
  message: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default FormAlertV2
